import { Document } from 'slate';
import { getEventTransfer } from 'slate-react';
import getCurrentCode from '../utils/getCurrentCode';
import deserializeCode from '../utils/deserializeCode';
import StyleTypes from '../../../types/StyleTypes';
/**
 * User is pasting content, insert it as text
 */

function onPaste(event, editor, next) {
  var value = editor.value;
  var data = getEventTransfer(event);
  var currentCode = getCurrentCode(value); // Only handle paste when selection is completely a code block

  var startBlock = value.startBlock,
      endBlock = value.endBlock;
  var inInlineCode = editor.value.activeMarks.find(function (mark) {
    return StyleTypes.CODE === mark.type;
  });

  if (inInlineCode && !data.text.includes('\n')) {
    //Only paste the plain text if its a single line
    return editor.insertText(data.text);
  }

  if (!currentCode || !currentCode.hasDescendant(startBlock.key) || !currentCode.hasDescendant(endBlock.key)) {
    return next();
  } // Convert to text if needed


  var text;

  if (data.type === 'fragment') {
    text = data.fragment.getTexts().map(function (t) {
      return t.text;
    }).join('\n');
  } else {
    text = data.text;
  } // Convert the text to code lines


  var lines = deserializeCode(text, currentCode.getIn(['nodes', 0, 'data', 'language'])).nodes;
  var fragment = Document.create({
    nodes: lines
  });
  return editor.snapshotSelection().insertFragment(fragment);
}

export default onPaste;